module.exports = __webpack_public_path__ + "static/media/netscapeIcon.ef12485e.png";